import Repository from './Repository';

import { vue } from '../main';

const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/instance/group`;

export default {
  /**
   * Add a Group to the Instance Group List
   * column 0 = left, 1 = right
   *
   * @param title
   * @param column
   * @param color
   * @returns {Promise<AxiosResponse<T>>}
   */
  add(title, column = 0, color = null) {
    return Repository.post(`${base}/add`, {
      title,
      column,
      color,
    });
  },

  /**
   * Modifies the given group.
   *
   * @param id
   * @param title
   * @param color
   * @returns {Promise<AxiosResponse<T>>}
   */
  modify(id, title = null, color = null) {
    return Repository.post(`${base}/modify`, {
      id,
      title,
      color,
    });
  },

  /**
   * Deletes the given group.
   *
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  delete(id) {
    return Repository.post(`${base}/delete`, {
      id,
    });
  },

  /**
   * Moves the given group's position.
   *
   * @param id
   * @param position
   * @param column
   * @returns {Promise<AxiosResponse<T>>}
   */
  move(id, position, column = 0) {
    return Repository.post(`${base}/move`, {
      id,
      position,
      column,
    });
  },

  /**
   * Moves the group upwards.
   *
   * @param group
   * @returns {*|Promise<AxiosResponse<T>>}
   */
  moveUp(group) {
    return this.move(group.id, group.order - 1, group.column);
  },

  /**
   * Moves the group downwards.
   *
   * @param group
   * @returns {*|Promise<AxiosResponse<T>>}
   */
  moveDown(group) {
    return this.move(group.id, group.order + 1, group.column);
  },

  /**
   * Moves the group to the left.
   *
   * @param group
   * @returns {*|Promise<AxiosResponse<T>>}
   */
  moveLeft(group) {
    return this.move(group.id, group.order, 0);
  },

  /**
   * Moves the group to the right.
   *
   * @param group
   * @returns {*|Promise<AxiosResponse<T>>}
   */
  moveRight(group) {
    return this.move(group.id, group.order, 1);
  },
};
